import { TargetDomEvent } from 'aws-rum-web';

export const getCssLocator = (label: string, value: string): string => {
    return `[${label}="${value}"]`;
};

export const DOMRegisteredEvents: TargetDomEvent[] = [   
    { event: 'click', cssLocator: getCssLocator('id','btn-tco-create') },
    { event: 'click', cssLocator: getCssLocator('id','btn-tco-calculate') },
    { event: 'click', cssLocator: getCssLocator('id','btn-update-tco-summary') },
    { event: 'click', cssLocator: getCssLocator('id','btn-getstarted-prioritization') },
    { event: 'click', cssLocator: getCssLocator('id','btn-getstarted-wave') },
    { event: 'click', cssLocator: getCssLocator('id','btn-getstarted-dependency') },
    { event: 'click', cssLocator: getCssLocator('id','btn-load-tco-assumption') },
    { event: 'click', cssLocator: getCssLocator('id','btn-apply-tco-assumption') },
    { event: 'click', cssLocator: getCssLocator('id','btn-onprem-server-hosttype') },
    { event: 'click', cssLocator: getCssLocator('id','btn-download-summary') },
    { event: 'click', cssLocator: getCssLocator('id','btn-download-wave') },
    { event: 'click', cssLocator: getCssLocator('id','btn-formbuilder-submit') },
    { event: 'click', cssLocator: getCssLocator('data-id', 'btn-ec2-override')},
    { event: 'click', cssLocator: getCssLocator('data-id', 'btn-table-download')},
];
